export default "__VITE_ASSET__662025a3__"